<template>
  <div class="eu-flex-item eu-basis_6">
    <p class="emd-text _color_subtle _type_caption eu-mb_1">
      {{ title }}
    </p>
    <p class="emd-card-grid__line">{{ dueAt | dateFormat('date') }}</p>
  </div>
</template>

<script>
export default {
  name: 'ChargesPaymentMethodDueAt',

  props: {
    title: {
      type: String,
      required: true
    },
    dueAt: {
      required: true
    }
  }
}
</script>
